import { configureStore, Store } from "@reduxjs/toolkit";
import rootReducer, { rootApiSlice } from "./rootReducer";
import { leaveInformationReducer } from "../pages/LeaveInformationPage/LeaveInformationSlice";

export const store: Store = configureStore({
    reducer: {
        root: rootReducer,
        leaveInformation: leaveInformationReducer,
        [rootApiSlice.reducerPath]: rootApiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({}).concat(rootApiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
